import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ListaAssociarUserTerceiroService } from './lista-associar-user-terceiro-grupo.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from '../../../../shared/services/commom.service';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'ngx-lista-associar-user-terceiro-grupo',
  templateUrl: './lista-associar-user-terceiro-grupo.component.html',
  styleUrls: ['./lista-associar-user-terceiro-grupo.component.scss']
})
export class ListaAssociarUserTerceiroGrupoComponent implements OnInit, OnDestroy {

  public formListGrupo = null;
  rowData: any;
  open: any;
  private listProdutos: any = [];

  @ViewChild('myTable', null)
  public table: DatatableComponent;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private service: ListaAssociarUserTerceiroService,
    private route: ActivatedRoute,
    private commomService: CommonService,
    private encriptyService: EncriptyUtilService,
    private datatableService: DatatableService,
    private notifications: NotificationsService,

  ) {
    this.rowData = [];

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);

    this.formListGrupo = this.formBuilder.group({
      produtoId: [this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'))],
      descricao: [null],
      nomeUsuario: [null],
    });

    this.pesquisarGrupo(this.formListGrupo.value);
  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table)
  }

  opencadastro() {

    this.router.navigate(['/pages/gestao-user-terceiro/cadastro-admin-grupo']);

  }

  pesquisarGrupo(data: any) {

    let params: HttpParams = new HttpParams();
    if (data.produtoId != null && data.produtoId != '') {
      params = params.append('produtoId', data.produtoId);
    }
    if (data.descricao != null && data.descricao != '') {
      params = params.append('descricao', data.descricao);
    }
    if (data.nomeUsuario != null && data.nomeUsuario != '') {
      params = params.append('nomeUsuarioTerceiro', data.nomeUsuario);
    }

    this.service.buscaGrupos(params)
      .subscribe(
        response => {
          this.rowData = response;
          if (this.rowData === null) {
            this.notifications.error(
              "Não existe produto para esse filtro."
            )
          }
        }
      );
  }

  gotoEditMenus(data) {
    let grupoId = this.encriptyService.encriptyBySecretKey("" + data.id).toString()
    let produtoId = this.encriptyService.encriptyBySecretKey("" + data.produtoId).toString()
    let params = { grupoId: grupoId, produtoId: produtoId }
    this.router.navigate(['../associar-user-terceiro-grupo'], { relativeTo: this.route, queryParams: params });
  }

  fillListProdutos() {
    return this.commomService.buscaProdutos()
      .subscribe(resp => this.listProdutos = resp);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
